import { useSession } from "@marta/core/features/auth/slice/auth-selectors";

import { CgSession } from "./auth-types";

export const useCgSession = () => useSession() as CgSession;
